export default "__VITE_ASSET__BVYRgXqL__"